import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAQQW8XSsEjXV27qE6i8NPf3iWOtqG9MYI",
  authDomain: "kanasante-waitlist.firebaseapp.com",
  projectId: "kanasante-waitlist",
  storageBucket: "kanasante-waitlist.firebasestorage.app",
  messagingSenderId: "893867545991",
  appId: "1:893867545991:web:039e39a32eb6f593336f22"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
